import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import styles from './index.module.scss';
import HTMLFlipBook from 'react-pageflip';
import Head from 'next/head';
import { IndexContext } from '@/stores';
import { Checkbox, Collapsible, Form, Toast } from '@douyinfe/semi-ui';
import classNames from 'classnames';
import useRequest from '@/utils/useRequest';
import { debounce, difference } from 'lodash';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const [active, setActive] = useState(0)
  const { setIsBecome } = useContext(IndexContext);
  const formRef = useRef<any>()
  const checkbox = useRef<any>()
  const request = useRequest()
  const router = useRouter()
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslations();

  const btnClick = useCallback(() => {
    // console.log('check', checkbox.current, formRef.current.getFormState().values);
    console.log(formRef.current.getFormState().values);
    const { product_category_ids, booth_type, booth_area } = formRef.current.getFormState().values
    if (!checkbox.current) {
      Toast.error({
        content: t('become.tips.allow'),
      })
      return
    }
    if (booth_type == 1 && booth_area < 18) {
      Toast.error({
        content: t('become.tips.size1'),
      })
      return
    }
    if (booth_type == 2 && booth_area < 12) {
      Toast.error({
        content: t('become.tips.size2'),
      })
      return
    }

    formRef.current.validate().then(async () => {
      const { data } = await request.post('/addExhibitorApply', {
        lang: 'cn',
        ...formRef.current.getFormState().values,
        product_category_ids: product_category_ids.join(',')
      })
      if (data.code == 200) {
        Toast.success({
          content: t('become.tips.success'),
          duration: 3,
        })
        formRef.current.reset()
        return;
      } else {
        Toast.error({
          content: data.msg,
          duration: 3,
        })
      }

    }).catch((err: any) => {
      console.log(err);

      Toast.error({
        content: t('common.tips.all'),
        duration: 3,
      })
    })

  }, [])

  const transOption = useCallback((arr: any = []) => {
    if (!arr.length) return []
    return arr?.map((item: any) => {
      return {
        // ...item,
        children: transOption(item.childlist),
        key: item.id,
        value: item.id,
        label: item?.[`name_${router.locale}`]
      }
    }).filter((item: any) => !!item.label)
  }, [router.locale])

  const clearNodes = useCallback((arr: any = []) => {
    console.log(arr, getFiled('product_category_ids'), difference(getFiled('product_category_ids'), arr));
    setTimeout(() => {
      formRef.current.setValue('product_category_ids', difference(getFiled('product_category_ids'), arr))
    })
  }, [])

  const getFiled = useCallback((filed: string) => {
    return formRef.current.getValue(filed)
  }, [formRef.current])

  // const getData = useCallback(async () => {
  //   const { data } = await request.get('/getProductCategoryList', {
  //     params: {
  //       // pid: 0
  //     }
  //   })
  //   console.log(data);

  // }, [])

  // useEffect(() => {
  //   setIsBecome(true)
  //   getData()
  //   return () => {
  //     setIsBecome(false)
  //   }
  // }, [])

  return (
    <div className={styles.container}>
      {getHead(navDetail)}
      <div>
        {
          router.locale === 'cn'
            ? <h1>第二十四届国际粉体、散料、流体加工展览会</h1> :
            <h1 style={{ marginBottom: '15px' }}>24<sup style={{ fontSize: '10px' }}>rd</sup> International Processing Trade Fair for Powder,Bulk Solids and fluids</h1>
        }
        {router.locale === 'cn' && <p>24<sup style={{ fontSize: '10px' }}>rd</sup> International Processing Trade Fair for Powder,Bulk Solids and fluids</p>}
        <div className={styles.expoInfo}>
          <p className={styles.time}>{t('common.time')}</p>
          <p className={styles.site}>{t('common.site')}</p>
        </div>
        <div className={styles.form}>
          <Form
            getFormApi={(formApi: any) => formRef.current = formApi}
            labelPosition="left"
            labelWidth="145px"
            labelAlign="right"
          >
            {
              (({ formState, values, formApi }) => (
                <div className={styles.box}>
                  <h2>{t('become.aplly')}</h2>
                  <p className={styles.tip}>{t('become.required')}</p>
                  <h3><span>*</span>{t('become.type')}</h3>
                  <div className={classNames([styles.type, 'type'])}>
                    <Form.RadioGroup
                      field="booth_type"
                      label={(<span></span>)}
                      style={{ flexDirection: 'row', gap: '20px 100px' }}
                      direction='vertical'
                      rules={[
                        { required: true, message: t('become.tips.required') },
                      ]}
                      onChange={() => {
                        formRef.current.reset(['booth_area1', 'booth_area'])
                      }}
                    >
                      <Form.Radio value="1" style={{ flex: 1 }}>
                        <div className={classNames([styles.radioRight, router.locale === 'en'&&styles.en])}>
                          <div className={styles.label}>
                            <p>{t('become.raw')}</p>
                            <span>{t('become.min1')}</span>
                          </div>
                          <Form.InputNumber
                            field="booth_area"
                            hideButtons
                            min={1}
                            disabled={getFiled('booth_type') != '1'}
                            placeholder={t('common.placeholder.size')}
                            label={(<span></span>)}
                            trigger='blur'
                            rules={[
                              { required: getFiled('booth_type') == '1', message: t('become.tips.required') },
                            ]}
                          />
                        </div>
                      </Form.Radio>
                      <Form.Radio value="2" style={{ flex: 1 }}>
                        <div className={classNames([styles.radioRight, router.locale === 'en'&&styles.en])}>
                          <div className={classNames([styles.label])}>
                            <p>{t('become.shell')}</p>
                            <span>{t('become.min2')}</span>
                          </div>
                          <Form.InputNumber
                            field={getFiled('booth_type') == '2' ? 'booth_area' : 'booth_area1'}
                            label={(<span></span>)}
                            disabled={getFiled('booth_type') != '2'}
                            placeholder={t('common.placeholder.size')}
                            hideButtons
                            min={1}
                            trigger='blur'
                            rules={[
                              { required: getFiled('booth_type') == '2', message: t('become.tips.required') },
                            ]}
                          />
                        </div>
                      </Form.Radio>
                    </Form.RadioGroup>
                  </div>
                  <h3 className={styles.formTitle}>{t('become.companyInfo')}</h3>
                  <div className={styles.exhInfo}>
                    <div className={styles.twoCol}>
                      <Form.Input
                        field="company"
                        placeholder={t('common.placeholder.company')}
                        label={(<span className={styles.required}>{t('become.companyName')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                      <Form.Input
                        field="truename"
                        placeholder={t('common.placeholder.contact')}
                        label={(<span className={styles.required}>{t('become.contact')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Input
                        field="mobile"
                        placeholder={t('common.placeholder.mobile')}
                        label={(<span className={styles.required}>{t('become.mobile')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                          {
                            validator: (rule, value) => {
                              const regex = /^1[3-9]\d{9}$/;
                              return regex.test(`${value}`);
                            }, message: t('become.tips.mobile')
                          }
                        ]}
                      />
                      <Form.Input
                        field="email"
                        placeholder={t('common.placeholder.email')}
                        label={(<span className={styles.required}>Email</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                          {
                            validator: (rule, value) => {
                              const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              return emailRegex.test(value);
                            }, message: t('common.tips.email')
                          }
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Select
                        field="company_type"
                        label={(<span className={styles.required}>{t('become.companyType')}</span>)}
                        placeholder={t('common.placeholder.select')}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                        optionList={transOption(navDetail?.list)}
                        onSelect={(value: any, option: any) => { }}
                      />
                      <Form.TreeSelect
                        field="product_category_ids"
                        style={{ height: 'auto', minHeight: '56px' }}
                        label={(<span className={styles.required}>{t('become.exhibitRange')}</span>)}
                        placeholder={t('common.placeholder.select')}
                        multiple
                        showLine
                        trigger='blur'
                        expandedKeys={getFiled('product_category_ids')}
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                        // leafOnly
                        checkRelation='unRelated'
                        treeData={transOption(navDetail?.list)}
                        onSelect={(selectedKey: string, selected: boolean, selectedNode: any) => {
                          console.log(selectedNode);

                          if (!selected && !!selectedNode.children.length) {
                            clearNodes([...selectedNode.children.map((item: any) => item.value), selectedKey])
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))
            }
          </Form>

          <div className={styles.footer}>
            <div className={styles.allow}>
              <Checkbox className='is-check' onChange={(e) => checkbox.current = e.target.checked}>
                <p>{t('become.allow')}</p>
              </Checkbox>
              <span style={{ marginLeft: '5px' }} onClick={() => setIsOpen(!isOpen)}>{t('become.agreement')}</span>
            </div>
            <Collapsible isOpen={isOpen}>
              <p className={styles.allowText}>
                {t('become.allowText')}
              </p>
            </Collapsible>
            <div className={styles.btns}>
              <div className={styles.subBtn} onClick={debounce(() => btnClick(), 500)}>{t('become.submit')}</div>
            </div>

          </div>
        </div>
      </div>
      <style jsx global>
        {
          `
            .semi-tree-select-selection .semi-tag{
              height:34px !important;
            }
            .semi-table-row,
            .semi-table-row-cell{
              height:80px;
              border-bottom:none;
            }
            .semi-page-item{
              font-size:16px;
              color: #333;
              margin:0 5px;
            }
            .semi-page-item:hover{
              background-color:#eaf3ee;
            }
            .semi-page-item-active{
              color:white !important;
              background:#6354a2 !important;
              border:none !important;
            }
            .semi-modal-header{
              border-bottom: 1px solid #ddd;
              padding-bottom: 30px;
            }
            .semi-modal-title{
              color:#094020;
              font-size:24px !important;
              font-weight:500 !important;
            }
            .semi-dropdown-item{
              justify-content:center;
            }
            .semi-form-field-label-text::after {
              display: none;
            }
            .semi-input-textarea{
              height:100%;
            }
            .semi-radioGroup{
              min-height: 50px;
              align-items: center;
            }
            .semi-tree-option {
              padding: 8px 12px !important;
            }
            .semi-form-field-label {
              font-weight: 500;
              padding-right: 20px;
              font-size: 16px;
              display:flex;
              align-items:flex-start;
              justify-content:right;
              margin-top:8px;
            }
            .semi-form-slot .semi-form-field-label{
              margin-top: 0px;
  
            }
            .custom .semi-form-field-label-text{
              margin-top:10px;
            }
            .semi-input-wrapper,
            .semi-select,
            .semi-tree-select {
              width: 100%;
              background: white;
              height: 56px;
              line-height: 56px;
              border: 1px solid #ddd;
              border-radius: 4px;
            }
            .semi-input-textarea-wrapper {
              width: 100%;
              background: white !important;
              border: 1px solid #ddd;
              border-radius: 4px;
              padding-top:10px;
            }
            .semi-input-wrapper:hover,
            .semi-select:hover,
            .semi-tree-select:hover {
              border: 1px solid #6354a2;
            }
            .semi-form-field {
              padding: 14px 0;
            }
            .semi-radioGroup{
              padding:0 !important;
            }
            .semi-radio-inner,
            .semi-radio-inner-display,
            .semi-checkbox-inner,
            .semi-checkbox-inner-display {
              width: 18px !important;
              height: 18px !important;
              background: white;
            }
            .semi-checkbox-checked .semi-checkbox-inner-display{
              border-style: #6354a2 !important;
              background: #6354a2 !important;
              box-shadow: none;
            }
            .semi-radio-checked .semi-radio-inner-display{
              border: 2px solid #6354a2 !important;
              background: white !important;
            }
            .semi-radio-inner-display .semi-icon{
              color: #6354a2;
              transform: scale(1.2) translate(-2px, -2px);
            }
            .semi-radio:hover .semi-radio-inner-display{
              border: 2px solid #6354a2 !important;
            }
            .is-check .semi-checkbox-inner-display,
            .is-check .semi-checkbox-inner-display:hover {
              background: white !important;
              // box-shadow: none;
            }
            .is-check .semi-checkbox-inner-checked span{
              background: #6354a2 !important;
              overflow:hidden;
            }
            .semi-icon-default {
              font-size: 18px !important;
            }
            .semi-input-wrapper-disabled,
            .semi-select-disabled{
              background-color:#f3f5f9;
            }
            .slot{
              position:relative;
            }
            .slot .semi-form-field-label {
              display: none !important;
            }
            .semi-form-slot .semi-form-field {
              padding: 0 !important;
            }
            .slot .semi-form-field {
              padding: 0;
              // padding: 12px 0;
            }
            .gender .semi-radio {
              align-items: center;
              zoom: 1.2;
            }
            .semi-input-number {
              width: 100%;
            }
            .type .semi-form-field-label {
              display: none !important;
            }
            .type .semi-radio-inner {
              transform: translateY(20px);
            }
            .type .semi-radio-content,
            .type .semi-form-field {
              flex: 1;
            }
            .type .semi-radioGroup-vertical {
              row-gap: 0;
            }
            .type .semi-select-selection {
              flex-grow: unset;
            }
            .type .semi-select-arrow {
              flex: 1;
              justify-content: left;
              padding-left: 5px;
            }
            .semi-table-container{
              margin-bottom: 20px;
            }
            .semi-table-cell-fixed-right-first{
              border-left:none !important;
            }
            .semi-checkbox-indeterminate .semi-checkbox-inner-display{
              background:#6354a2;
              box-shadow: 0 0 0 1px #6354a2;
            }
            .semi-table-row-head{
              color:#999 !important;
              white-space: nowrap;
            }
            @media screen and (max-width: 887px) {
              .semi-form-field-label {
                justify-content: left !important;
                padding:0 0 20px !important;
                margin-top:0;
              }
              .semi-form-field {
                flex-direction: column;
                padding-top: 0 !important;
              }
              .type .semi-radioGroup{
                flex-direction: column  !important;
                gap:20px !important;
              }
              .type .semi-form-field{
                padding:0 !important;
              }
              .semi-form-field-label-text{
                white-space:nowrap;
              }
            }
          `
        }
      </style>
    </div>
  );
};


